// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2222 ? "d0dec1b0" : chunkId) + "." + {"298":"eab7d39dbf6b5727","642":"4d6b65f281f71884","2222":"32f37389fc221c1b","2631":"b27f1db13f74f6a7","4856":"3481f8725f331db0","9792":"c5edcff323982cff"}[chunkId] + ".js";
};